import type { DataExplorerTreeShellProps } from './types';
import { useDataExplorerAppearance } from './appearanceContext';
import { resolveDataExplorerAppearance } from './theme';
import { cn } from './utils';

export function DataExplorerTreeShell({
  title,
  subtitle,
  toolbar,
  footer,
  children,
  appearance,
  className,
  classNames,
}: DataExplorerTreeShellProps) {
  const theme = resolveDataExplorerAppearance(
    useDataExplorerAppearance(appearance),
  );
  const hasHeader = !!title || !!subtitle || !!toolbar;

  return (
    <section
      className={cn(
        theme.slots.treeShellRoot,
        classNames?.root,
        className,
      )}
    >
      {hasHeader ? (
        <div
          className={cn(
            theme.slots.treeShellHeader,
            classNames?.header,
          )}
        >
          <div className="min-w-0 flex-1">
            {title ? (
              <div className={cn(theme.slots.treeShellTitle, classNames?.title)}>
                {title}
              </div>
            ) : null}
            {subtitle ? (
              <div
                className={cn(
                  theme.slots.treeShellSubtitle,
                  classNames?.subtitle,
                )}
              >
                {subtitle}
              </div>
            ) : null}
          </div>

          {toolbar ? (
            <div className={cn(theme.slots.treeShellToolbar, classNames?.toolbar)}>
              {toolbar}
            </div>
          ) : null}
        </div>
      ) : null}

      <div className={cn(theme.slots.treeShellBody, classNames?.body)}>
        {children}
      </div>

      {footer ? (
        <div className={cn(theme.slots.treeShellFooter, classNames?.footer)}>{footer}</div>
      ) : null}
    </section>
  );
}
